const MessageStatus = {
    DELIVERED: 'DELIVERED',
    SENT: 'SENT',
    WAITING: 'WAITING',
    MODERATION: 'MODERATION',
    DENIED: 'DENIED',
    NOT_SENT: 'NOT_SENT',
    UNDELIVERED: 'UNDELIVERED'
};

module.exports = MessageStatus;